import './upper-ribbon.scss';
import fuelIcon from '../../../images/records_quota.svg';
import moment from 'moment';

export const name = 'ecommerceUpperRibbonDirective';
export default function ecommerceUpperRibbonDirective() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'E',
    template: require('./upper-ribbon.html'),
    scope: {
      isUpperRibbonRequired:"=isUpperRibbonRequired",
      stateChangeCallback:"=stateChangeCallback",
      ecommerveDataCallback:"=callback"
    },

    controller: upperRibbonController,
    controllerAs: 'vm',
    bindToController: true
  };

  return directive;
}

function upperRibbonController($translate, ecommerceFactory, $state, $scope, $sce) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;
  vm.fuelIcon = fuelIcon;

  ecommerceFactory.createEcommerceTracking(upperRibbonCallback);

  function upperRibbonCallback(ecommerceInfo) {
    vm.isWarningRequired = false;
    vm.isAlertRequired = false;
    vm.isInfo = false;
    vm.isDismissed = false;
    vm.ecommerceInfo = ecommerceInfo;
    vm.isItTheLastTier = false;
    vm.isQuantityForFreeInProgressNow = false;
    vm.notLastTierAndCountBiggerThanForFree = false;
    let daysLeft = moment(ecommerceInfo.nextResetTime).endOf('day').diff(moment(), 'days');
    vm.daysLeft = daysLeft < 0 ? 0 : daysLeft;
    if(ecommerceInfo.ecommerceEnabled) {
//todo check if need-
      let dayInMonth = '<span class="blue">' + moment(ecommerceInfo.nextResetTime).format("Do") + '</span>';
      $translate.onReady(function(){
        vm.refreshTime = $translate.instant('imposer.composer-main.refresh_occurs', [dayInMonth]);
        vm.marketplaceTranslated = $translate.instant('imposer.composer-main.marketplace');
        //let marketPlaceLink = '<a href="/market/#/product/composer" class="blue">' + vm.marketplaceTranslated + '</a>';
        let marketPlaceLink = '<a href="/market/#/product/creativity-pack" class="blue">' + vm.marketplaceTranslated + '</a>';
        //{printOSBaseUrl}/market/#/product/creativity-pack
        vm.increaseRecords = $translate.instant('imposer.composer-main.increase_records', [marketPlaceLink]);
      });
      vm.to_trusted = function(html_code) {
        return $sce.trustAsHtml(html_code);
      };

/////

      let usedPercentage = 0;
      vm.isItTheLastTier = ecommerceInfo.nextTierNumberOfRecords === ecommerceInfo.maxDefinedNumberOfRecords;


      if(ecommerceInfo.isGrantableWithQuantity){
        if(ecommerceInfo.quantityForFree >= ecommerceInfo.count){
          usedPercentage = Math.round(+((ecommerceInfo.count / ecommerceInfo.quantityForFree).toFixed(6).match(/^-?\d+(?:\.\d{0,2})?/)[0] * 100));
        }
        else{
          vm.usageForPaymentOrLimitation = Math.max(ecommerceInfo.count - ecommerceInfo.quantityForFree, 0);
          usedPercentage = Math.round(+((vm.usageForPaymentOrLimitation / ecommerceInfo.nextTierNumberOfRecords).toFixed(6).match(/^-?\d+(?:\.\d{0,2})?/)[0] * 100));
        }
      }
      else{
        vm.isItTheLastTier = true;
        vm.usageForPaymentOrLimitation = Math.max(ecommerceInfo.count - ecommerceInfo.quantityForFree, 0);
        usedPercentage = Math.round(+((ecommerceInfo.count / ecommerceInfo.maxDefinedNumberOfRecords).toFixed(6).match(/^-?\d+(?:\.\d{0,2})?/)[0] * 100));
      }
      if(!vm.isItTheLastTier && (ecommerceInfo.count <= ecommerceInfo.quantityForFree)){
        vm.currentTierInProgress = ecommerceInfo.quantityForFree;
        vm.isQuantityForFreeInProgressNow = true;
      }
      else{
        vm.currentTierInProgress = (ecommerceInfo.isGrantableWithQuantity)? ecommerceInfo.nextTierNumberOfRecords : ecommerceInfo.maxDefinedNumberOfRecords;
      }

      if(!vm.isItTheLastTier && (ecommerceInfo.count > ecommerceInfo.quantityForFree)){
        vm.notLastTierAndCountBiggerThanForFree = true;
        vm.countOrUsageForPayment = vm.usageForPaymentOrLimitation;
      }
      else if(vm.isItTheLastTier && ecommerceInfo.isGrantableWithQuantity){//to test
        vm.countOrUsageForPayment = vm.usageForPaymentOrLimitation;
      }
      else{
        vm.countOrUsageForPayment = ecommerceInfo.count;
      }
      vm.leftPresetage = 100 - usedPercentage;
      if (vm.leftPresetage <= 5) {
        vm.isAlertRequired = true;
      } else if (vm.leftPresetage <= 10) {
        vm.isWarningRequired = true;
      } else {
        vm.isDismissed = localStorage.getItem("isUpperRibbonDismissed") === null ? false : true;
        vm.isInfo = true;
        if(vm.leftPresetage === 100 && ecommerceInfo.count > 0) {
          vm.leftPresetage = 99;
        }
      }
    }

    if(vm.ecommerveDataCallback){
      vm.ecommerveDataCallback(ecommerceInfo);
    }
  }

  if($state.current.name === 'quota'){
    vm.isQuotaState = true;
  }

  vm.showDetails = function(){
    $state.transitionTo('quota');
  };

  vm.dismiss = function(){
    vm.isDismissed = true;
    localStorage.setItem("isUpperRibbonDismissed", "true");

    if(vm.stateChangeCallback){
      vm.stateChangeCallback(false);
    }
  };

  $scope.$watch("vm.isUpperRibbonRequired", function(){
    vm.isDismissed = localStorage.getItem("isUpperRibbonDismissed") === null ? false : true;
  });

  vm.numberWithCommas = function(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
}
